<!--<mat-tool-bar class="toolbar row" color="accent">
    <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 d-none d-sm-block">
        <div style="margin-top:12px;">
           
            <img class="mt-1" *ngIf="!isIconOnly" src="../../../../../Scripts/libs/assets/Images/Hyundai.png">
            <img class="mt-1" *ngIf="isIconOnly" src="../../../../../Scripts/libs/assets/Images/small_Hyundai.png">
        </div>
    </div>
    <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 text-center">
        <h5 id="appTitle" style="margin-top:20px;" color="primary">{{appDetails.title}}</h5>
    </div>
    <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 text-right d-none d-sm-block">
        <label *ngIf="loggedInUserDetails" style="margin-top:18px; margin-right:2px;">
            <mat-icon class="userIcon pr-2" color="accent">account_circle</mat-icon>
            <span id="userID" color="primary">&nbsp;{{loggedInUserDetails.FullName}}</span>
        </label>
    </div>
</mat-tool-bar>-->
<app-side-menu></app-side-menu>
<app-error-page [errorMessage]="'You are not authorized to access this application.'" *ngIf="loggedInUserDetails && loggedInUserDetails.UserRole == ''"></app-error-page>
